const isSameValue = (current: unknown, next: unknown): boolean => {
  if (Array.isArray(current) && Array.isArray(next)) {
    return current.length === next.length && current.every((item, index) => item === next[index]);
  }

  return Object.is(current, next);
};

const assignChangedProperties = <T extends object>(target: T, updates: Partial<T>): void => {
  for (const key of Object.keys(updates) as (keyof T)[]) {
    const next = updates[key] as T[keyof T];

    if (!isSameValue(target[key], next)) {
      target[key] = next;
    }
  }
};

export default assignChangedProperties;
